/*
    Should be rendered within DrawerContainer
    Closes the drawer container

    allows for title to past through when rendering the snippet
    the title can be any form of html
    see side cart for example

*/


import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { CartMain } from "../Cart/CartMain";
import { debounce } from 'lodash';

@Component
export class DrawerHeader extends ThemeComponent {
    @Ref closeButton!: HTMLButtonElement;
    @Ref({ required: false }) count!: HTMLElement;
    @Ref({ required: false }) viewCart!: HTMLButtonElement;

    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    public changeClose(close: string) {
        this.close = close;

        // Use the private backing field to dispatch
        this._onCloseChange.dispatch(close);
    }

    /** Initialise component */
    init() {
        this.updateCount();
        this.$listen(this.closeButton, 'click', () => {
            this._onCloseChange.dispatch(this.close);
        });

        this.setVatNumber();
    }

    /**
     * Update cart count.
     * For the side cart drawer.
     * @returns
     */
    updateCount() {
        if (!this.count) { return; }
        const cartMain = this.parentElement?.querySelector('cart-main') as CartMain;

        if (!cartMain) { return; }
        this.$subscribe(cartMain.onCartItemCountChange, debounce((value) => {
            this.count.innerHTML = value;
        }, 300));
    }

    /**
     * Sets session storage for VAT Number
     */
    setVatNumber() {
        const vatNumberInput = document.querySelector<HTMLInputElement>('[data-ref="vatNumber"]');
        const viewCartButton = document.querySelector<HTMLButtonElement>('[data-ref="viewCart"]');

        if (vatNumberInput) {
            const sessionVatNumber = sessionStorage.getItem('vatNumber');
            vatNumberInput.value = sessionVatNumber || "";

            vatNumberInput.addEventListener('input', () => {
                const alphanumericRegex = /^[a-z0-9]+$/i;
                if (alphanumericRegex.test(vatNumberInput.value) || vatNumberInput.value === "") {
                    sessionStorage.setItem('vatNumber', vatNumberInput.value);
                }
            });
        }

        if (viewCartButton) {
            this.$listen(viewCartButton, 'click', (e) => {
                const vatNumberValue = vatNumberInput?.value || '';
                sessionStorage.setItem('vatNumber', vatNumberValue);
            });
        }
    }
}
